  <div class="col tir-detail">
  <div class="d-flex row-small row-margin w-100">
    <div class="w-100 tabs-container">
      @if (canScrollRight() || canScrollLeft()) {
        <button
          class="tab-nav-btn tab-nav-btn-left"
          (click)="scrollTabs('left')"
          [class.disabled]="!canScrollLeft()"
          [disabled]="!canScrollLeft()">
          <img src="assets/icon/floating.svg" alt="Scroll left" style="transform: rotate(180deg);">
        </button>
      }

      <div class="tabs-wrapper" #tabsWrapper>
        <ul class="nav nav-tabs not-selectable" #tabsList>
          @if (isTabAvailable(1)) {
            <li class="nav-item epc-tab">
              <a class="nav-link" [class.active]="tab() === 1" [routerLink]="[]" [queryParams]="{tab: 'general'}" queryParamsHandling="merge">
                {{'GLOBAL.GENERAL' | translate}}
              </a>
            </li>
          }
          @if (isTabAvailable(2)) {
            <li class="nav-item epc-tab">
              <a class="nav-link" [class.active]="tab() === 2" [routerLink]="[]" [queryParams]="{tab: 'analysis'}" queryParamsHandling="merge">
                {{'GLOBAL.DONNEES_ANALYSE' | translate}}
                @if (tir()?.donneeAnalyseRenseignees) {
                  <i class="fas fa-check"></i>
                }
              </a>
            </li>
          }
          @if (isTabAvailable(3)) {
            <li class="nav-item epc-tab">
              <a class="nav-link" [class.active]="tab() === 3" [routerLink]="[]" [queryParams]="{tab: 'design'}" queryParamsHandling="merge">
                {{'GLOBAL.DESIGN' | translate}}
              </a>
            </li>
          }
          @if (isTabAvailable(4)) {
            <li class="nav-item epc-tab">
              <a class="nav-link" [class.active]="tab() === 4" [routerLink]="[]" [queryParams]="{tab: 'load'}" queryParamsHandling="merge">
                {{'GLOBAL.LOAD' | translate}}
              </a>
            </li>
          }
          @if (isTabAvailable(5)) {
            <li class="nav-item epc-tab">
              <a class="nav-link" [class.active]="tab() === 5" [routerLink]="[]" [queryParams]="{tab: 'holes'}" queryParamsHandling="merge">
                {{'GLOBAL.TROUS' | translate}}
              </a>
            </li>
          }
          @if (isTabAvailable(6)) {
            <li class="nav-item epc-tab">
              <a class="nav-link" [class.active]="tab() === 6" [routerLink]="[]" [queryParams]="{tab: 'deliveries'}" queryParamsHandling="merge">
                {{'DELIVERIES.DELIVERIES' | translate}}
              </a>
            </li>
          }
          @if (isTabAvailable(7)) {
            <li class="nav-item epc-tab">
              <a class="nav-link" [class.active]="tab() === 7" [routerLink]="[]" [queryParams]="{tab: 'vibrations'}" queryParamsHandling="merge">
                {{'GLOBAL.VIBRATIONS' | translate}}
              </a>
            </li>
          }
          @if (isTabAvailable(8)) {
            <li class="nav-item epc-tab">
              <a class="nav-link" [class.active]="tab() === 8" [routerLink]="[]" [queryParams]="{tab: 'fragmentation'}" queryParamsHandling="merge">
                {{'GLOBAL.FRAGMENTATION' | translate}}
              </a>
            </li>
          }
          @if (isTabAvailable(9)) {
            <li class="nav-item epc-tab">
              <a class="nav-link" [class.active]="tab() === 9" [routerLink]="[]" [queryParams]="{tab: 'load-haul'}" queryParamsHandling="merge">
                {{'FEATURES.LOAD_AND_HAUL' | translate}}
              </a>
            </li>
          }
          @if (isTabAvailable(10)) {
            <li class="nav-item epc-tab">
              <a class="nav-link" [class.active]="tab() === 10" [routerLink]="[]" [queryParams]="{tab: 'fleet'}" queryParamsHandling="merge">
                {{'FEATURES.FLEET_MANAGEMENT' | translate}}
              </a>
            </li>
          }
          @if (isTabAvailable(11)) {
            <li class="nav-item epc-tab">
              <a class="nav-link" [class.active]="tab() === 11" [routerLink]="[]" [queryParams]="{tab: 'files'}" queryParamsHandling="merge">
                {{'GLOBAL.FICHIERS' | translate}}
              </a>
            </li>
          }
          @if (isTabAvailable(12)) {
            <li class="nav-item epc-tab">
              <a class="nav-link" [class.active]="tab() === 12" [routerLink]="[]" [queryParams]="{tab: 'customer-feedback'}" queryParamsHandling="merge">
                {{'GLOBAL.CUSTOMER_FEEDBACK' | translate}}
              </a>
            </li>
          }
          @if (isTabAvailable(13)) {
            <li class="nav-item epc-tab">
              <a class="nav-link" [class.active]="tab() === 13" [routerLink]="[]" [queryParams]="{tab: 'supplier-feedback'}" queryParamsHandling="merge">
                {{'GLOBAL.SUPPLIYER_FEEDBACK' | translate}}
              </a>
            </li>
          }
          @if (isTabAvailable(14)) {
            <li class="nav-item epc-tab">
              <a class="nav-link" [class.active]="tab() === 14" [routerLink]="[]" [queryParams]="{tab: 'environment'}" queryParamsHandling="merge">
                {{'GLOBAL.ENVIRONMENT' | translate}}
              </a>
            </li>
          }
          @if (isTabAvailable(15)) {
            <li class="nav-item epc-tab">
              <a class="nav-link" [class.active]="tab() === 15" [routerLink]="[]" [queryParams]="{tab: 'drilling'}" queryParamsHandling="merge">
                {{'EXPERTAB.DRILLING' | translate}}
              </a>
            </li>
          }
        </ul>
    </div>

    @if (canScrollRight() || canScrollLeft()) {
      <button
        class="tab-nav-btn tab-nav-btn-right"
        (click)="scrollTabs('right')"
        [class.disabled]="!canScrollRight()"
        [disabled]="!canScrollRight()">
        <img src="assets/icon/floating.svg" alt="Scroll right">
      </button>
    }
  </div>
</div>
<div class="g-0 ps-2 pe-0 pt-2 tir-detail__content">
  @if (tab() == 1) {
    <app-general [tirId]="this.tir().tirId" [apiEndPoint]="'WorkflowSteps'" [racine]="dossierRacine" (securityIsChange)="securityIsChange($event)" class="w-100"></app-general>
  }
  @if (tab() == 2) {
    <app-blast-kpi [tabConfigSaisie]="configSaisieSite" [tabDonneesAnalyse]="donneesAnalyseTir"
      [donneesChargees]="initAnalyseFaite()" [estProjet]="false" [estTir]="true" [tirId]="this.tir().tirId"
      [kpiIsVerified]="kpiIsVerified()"
      (verifyToggled)="onKpiVerifiedChange($event)"
    (rechargerDonnees)="chargerDonneesAnalyse()" class="w-100"></app-blast-kpi>
  }
  @if (showBlastDesignTab() && tab() == 3) {
    <app-blast-design [blast]="blast()" [tirId]="this.tir().tirId" class="w-100"></app-blast-design>
  }
  @if (showBlastLoadTab() && tab() == 4) {
    <app-blast-load [tirId]="this.tir().tirId" class="w-100"></app-blast-load>
  }
  @if (tab() == 5) {
    <app-blast3-dviewer-lazy [tirId]="this.tir().tirId"></app-blast3-dviewer-lazy>
  }
  @if (tab() == 6 ) {
    <app-deliveries [tirId]="this.tir().tirId" class="w-100"></app-deliveries>
  }
  @if (tab() == 7 && initVibrationFaite()) {
    @if (!usePostgresDatabaseForVibrations()) {
      <app-donnees-vibration [tabDonneesVibrationNewModel]="oldTabVibrationsChart"
        [tabDonneesVibrationOldModel]="tabVibrationsOldModel" [tabControlPoints]="tabControlPoints"
        [donneesChargees]="initVibrationFaite()" [proprietesAffichees]="propDonneeVibration"
      (rechargerDonnees)="chargerVibrations()" class="w-100"></app-donnees-vibration>
    }
    @if (usePostgresDatabaseForVibrations()) {
      <app-vibration-detail class="w-100" [controlPoints]="tabControlPoints" [vibrationRecords]="newTabVibrationsChart"
      [totalRecords]="totalRecords" [tirId]="this.tir().tirId" [tirName]="this.tir().nom"></app-vibration-detail>
    }
  }
  @if (tab() == 8) {
    <app-fragmentation [blastId]="this.tir().tirId" class="w-100"></app-fragmentation>
  }
  @if (tab() == 9) {
    <app-donnees-suivi-operationnel [tabDonneesSuivi]="tabRotations"
      [proprietesAfficheesDonneeSuivi]="propDonneeSuivi" [donneesChargees]="initSuiviFaite()" [estProjet]="false"
      [tirId]="this.tir().tirId" [projet]="projet()"  (rechargerDonnees)="chargerDonneesSuivi()" class="w-100">
    </app-donnees-suivi-operationnel>
  }
  @if (tab() == 10) {
    <ng-container class="dashboard">
      <app-metabase-dashboard componentSelector="app-tir-detail" class="w-100" [blast]="currentBlastName"></app-metabase-dashboard>
    </ng-container>
  }
  @if (tab() == 11  && initDossierFaite()) {
    <app-file-explorer [apiEndPoint]="'WorkflowSteps'" [id]="etape()?.workflowEtapeInstanceId"
      (modifDossier)="modifDossier($event)" [racine]="dossierRacine" [hauteurExplorer]="hauteurListe"
      [blastName]="tir().nom"
    class="w-100"></app-file-explorer>
  }
  @if (tab() == 12) {
    <app-customer-feedback class="w-100" [tirId]="this.tir().tirId" [regionId]="regionId()" [surveyResponses]="customerSurveyResponses()" (rechargerDonnees)="chargerCustomerSurveyResponses()"
    [surveyJsonForm]="surveyJsonForm()" [hasWritePermission]="hasWriteCustomerSurvey()"></app-customer-feedback>
  }
  @if (tab() == 13) {
    <app-supplier-feedback class="w-100" [tirId]="this.tir().tirId" [regionId]="regionId()" [surveyResponses]="supplierSurveyResponses()" (rechargerDonnees)="chargerSupplierSurveyResponses()"
    [surveyJsonForm]="surveyJsonForm()" [hasWritePermission]="hasWriteSupplierSurvey()"></app-supplier-feedback>
  }
  @if (tab() == 14) {
    @for (envTirId of [this.tir().tirId]; track envTirId) {
      <app-blast-environment [tirId]="envTirId" [blast]="blast()" class="w-100"></app-blast-environment>
    }
  }
  @if (tab() == 15 && initDrillingFaite() && blastDrillingData()) {
    <blast-drilling-panel
      [blast]="blastDrillingData()!"
      [shiftConfig]="shiftConfig"
      (addSession)="onDrillingAddSession()"
      (editSession)="onDrillingEditSession($event)"
      (deleteSession)="onDrillingDeleteSession($event)">
    </blast-drilling-panel>
  }
</div>
</div>